import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class ProducerCommissions extends RestApiModel {
  static getResourceEndpoint() {
    return '/GetProducerCommissions';
  }
}

export default ProducerCommissions;
